import TIMActions from "../components/GridTableUtils/TIMActions";

export const columnsGroups = [
    {
        field: 'firstName',
        headerName: 'First Name',
        flex: 1
    },
    {
        field: 'lastName',
        headerName: 'Last Name',
        flex: 1
    },
    {
        field: 'email',
        headerName: 'Email',
        flex: 1
    },
    {
        field: 'type',
        headerName: 'Type',
        flex: 1,
        valueFormatter: (value)=> {
            if(!value) return "";
            return value.charAt(0).toUpperCase() + value.slice(1);
        }

    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1
    },
    {
        field: 'actions',
        headerName: 'ACTIONS',
        flex: 1,
        renderCell: TIMActions
    },
];